module.exports = __webpack_public_path__ + "03_glasses_brown.e3f1ad7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/03_glasses_brown.png
// module id = fx6E
// module chunks = 0